import { combineReducers } from 'redux'
import formTypeSelected from './formTypeSelected'
import groupSelect from './groupSelect'
import formViewSelected from './formViewSelected'
import values from './values'
import fields from './fields'
import bottomNav from './bottomNav'
import formID from './formID'
import snackbar from './snackbar'
import previewResponseView from './previewResponseView'
import changed from './changed'
import saveAttempted from './saveAttempted'
import expanded from './expanded'
import bottomMenuOpen from './bottomMenuOpen'
import customLandingPage from './customLandingPage'

export default combineReducers({
	fields,
	formTypeSelected,
	formViewSelected,
	groupSelect,
	values,
	bottomNav,
	formID,
	snackbar,
	previewResponseView,
	changed,
	saveAttempted,
	expanded,
	bottomMenuOpen,
	customLandingPage,
})
